module.exports = __webpack_public_path__ + "static/media/doctor-2.18ed8575.webp";